// extracted by mini-css-extract-plugin
export default {"MainCont":"Packaging_MainCont__UfPTR","LeftCont":"Packaging_LeftCont__Cvyci","RightCont":"Packaging_RightCont__Sb6b+"};